/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Kategorie licence pro admin dashboard předplatných. Dopočítává ji backend jako reálný sloupec
 * ve view `tax_subscription_licence_overview`, takže je serverově filtrovatelná i řaditelná.
 *
 * Slučuje stav licence a fázi automatu do jedné hodnoty - jako **hodnota sloupce** má každý řádek
 * právě jednu kategorii, tu nejkonkrétnější, která na něj sedí.
 *
 * Jako **dlaždice** disjunktní nejsou: `ACTIVE` je nadmnožina `PAYMENT_BEFORE_DUE`,
 * `PAYMENT_OVERDUE` a `ENDED`, takže součet dlaždic je vyšší než počet licencí. Ta nadmnožina je
 * přesně `licenceStatus === ACTIVE` - proto se dlaždice `ACTIVE` i počítá i filtruje přes stav
 * licence, ne přes tenhle sloupec (viz `writeTileFilter`).
 *
 * Frontend hodnotu jen zobrazuje. Prahy automatu (3 / 7 / 1 dní) sem nepatří - žijí na backendu.
 */
export enum TaxSubscriptionCategory {
    /** Status ACTIVE. Jako hodnota sloupce zbytková, jako dlaždice nadmnožina všech aktivních. */
    ACTIVE = "ACTIVE",
    /** Status ACTIVE a nejnovější předpis je před splatností (3 dny měsíční / 7 dní roční). */
    PAYMENT_BEFORE_DUE = "PAYMENT_BEFORE_DUE",
    /** Status ACTIVE a nejnovější předpis je po splatnosti (do graceDueDate). */
    PAYMENT_OVERDUE = "PAYMENT_OVERDUE",
    /** Status ACTIVE, výpověď podaná, licence dobíhá zaplacené období. */
    ENDED = "ENDED",
    /** Status ACTIVATION_PENDING. */
    ACTIVATION_PENDING = "ACTIVATION_PENDING",
    /** Status TERMINATED - licence je vypnutá a běží jí výpovědní doba. */
    TERMINATED = "TERMINATED",
    /** Status TRIAL. */
    TRIAL = "TRIAL",
    /** Status NEW a cokoli nezařazeného. Dlaždici nedostane. */
    OTHER = "OTHER",
}

/**
 * Kategorie, které se zobrazují jako dlaždice, v pořadí zobrazení. `OTHER` mezi nimi není.
 *
 * Tři aktivní podstavy jdou záměrně hned za `ACTIVE` - z popisků („Aktivní", „Aktivní, před
 * splatností", …) je pak vztah nadmnožina-podmnožina čitelný bez vysvětlivky.
 */
export const SUBSCRIPTION_TILE_CATEGORIES = [
    TaxSubscriptionCategory.ACTIVE,
    TaxSubscriptionCategory.PAYMENT_BEFORE_DUE,
    TaxSubscriptionCategory.PAYMENT_OVERDUE,
    TaxSubscriptionCategory.ENDED,
    TaxSubscriptionCategory.ACTIVATION_PENDING,
    TaxSubscriptionCategory.TERMINATED,
    TaxSubscriptionCategory.TRIAL,
] as const;
